import { apiHeader } from "@bisom/web_package";
import config from "@/config/env/index";
import { kc } from "@/main";
import axios from "@/utils/axiosInterceptors";
import { getApiV3WithDivision } from "@/utils/apiBisomV3";
import handleLogout from "../logout";

const apiEndpoint = async () => {
  return await `${getApiV3WithDivision()}/users`;
};

const getUserInfos = async () => {
  try {
    const tokenParsed = kc?.idTokenParsed;
    const organizationId = tokenParsed?.organization?.[0];
    const divisionId = tokenParsed?.division?.[0];
    const headerParams = { ...apiHeader() };

    if (organizationId && divisionId) {
      const url = `${config.api_bisom_url}api/v3/organizations/${organizationId}/divisions/${divisionId}/users/information`;
      const response = await axios.get(url, headerParams);

      return Promise.resolve(response.data);
    } else {
      handleLogout();
      throw new Error(
        "Votre configuration n'est pas complète, merci de vous rapprocher de l'administrateur de votre établissement"
      );
    }
  } catch (error) {
    handleLogout();
    return Promise.reject(error);
  }
};

const fetchUserDivisions = async () => {
  try {
    const params = { ...apiHeader() };
    let url = await apiEndpoint();
    url = `${url}/divisions`;
    const result = await axios.get(url, params);

    return Promise.resolve(result.data);
  } catch (error) {
    return Promise.reject(error);
  }
};

const fetchUserManagedOrganizations = async () => {
  try {
    const params = { params: { divisions: true }, ...apiHeader() };
    let url = await apiEndpoint();
    url = `${url}/managed_organizations`;
    const result = await axios.get(url, params);

    return Promise.resolve(result.data);
  } catch (error) {
    return Promise.reject(error);
  }
};

const postUserDivision = async (body: object) => {
  try {
    const url = await apiEndpoint();
    const headerParams = { ...apiHeader() };

    const response = await axios.post(`${url}/divisions`, body, headerParams);

    return Promise.resolve(response.data);
  } catch (error) {
    return Promise.reject(error);
  }
};

export default {
  getUserInfos,
  fetchUserDivisions,
  fetchUserManagedOrganizations,
  postUserDivision,
};
